import moment, { MomentInput } from 'moment';

export default function fromISOHumanly(ISO: MomentInput, format = 'D/M/Y, h:mm a'): string {
  if (ISO) { return moment(ISO).format(format); }
  return '';
}
